import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Phone, MessageCircle } from 'lucide-react';
import config from '@/config';

export default function ContactCTA() {
  const { t } = useTranslation();

  const whatsappUrl = `https://wa.me/${config.contact.whatsapp}?text=${encodeURIComponent('Hi! I need help with your products/services.')}`;

  return (
    <section className="bg-gradient-to-r from-secondary to-secondary-dark px-4 py-16 text-white sm:px-6 lg:px-8">
      <div className="mx-auto max-w-4xl text-center">
        <h2 className="text-3xl font-bold sm:text-4xl">{t('home.ctaTitle')}</h2>
        <p className="mt-3 text-lg text-white/80">{t('home.ctaSubtitle')}</p>

        <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <a
            href={`tel:${config.contact.phone}`}
            className="flex items-center gap-2 rounded-full bg-white px-6 py-3 font-semibold text-secondary shadow-lg transition-transform hover:scale-105"
          >
            <Phone size={20} />
            {config.contact.phone}
          </a>
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 rounded-full border-2 border-white px-6 py-3 font-semibold text-white transition-colors hover:bg-white/10"
          >
            <MessageCircle size={20} />
            {t('contact.whatsappUs')}
          </a>
          <Link
            to="/contact"
            className="rounded-full border-2 border-white px-6 py-3 font-semibold text-white transition-colors hover:bg-white/10"
          >
            {t('home.ctaButton')}
          </Link>
        </div>
      </div>
    </section>
  );
}
